// extracted by mini-css-extract-plugin
export default {"ManageCoverPopover":"KRQwx9nOCSFousF2fxeB"};